class PdpPurchaseOptions extends HTMLElement {
  constructor() {
    super();

    // Initialize state variables
    // this.purchaseType = 'oneTime';
    this.purchaseType = null;
    //this.purchaseType = 'subscribeAndSave'
    this.toggleOn = false;
    this.cart = {};
    this.cartMetaData = window.__abc?.ShopifyCartData?.cartMetaFields || [];
    this.neededForClubDiscount = 4;
    this.activeClubMember = false;
    this.clubDiscountEligible = false;
    this.athleticClubMemberProduct = false;
    this.isAvailable = true;
    this.buildMySubscriptionBtn = null;
    this.productId = null;
    this.bundleLines = [];
    this.preMembershipSubscriber = false;
    this.employee = false;
    // Bind event handlers
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleMembershipToggle = this.handleMembershipToggle.bind(this);
    this.handleClubPriceProgressBar = this.handleClubPriceProgressBar.bind(this);
    this.launchSubBuilder = this.launchSubBuilder.bind(this);
    this.handleCartUpdateEnriched = this.handleCartUpdateEnriched.bind(this);
  }

  connectedCallback() {
    // Parse cart data from attribute
    const cartData = this.getAttribute('cart');
    try {
      this.cart = JSON.parse(cartData);
    } catch (e) {
      console.error('Invalid JSON for cart attribute:', e);
    }
    //active-club-member
    this.activeClubMember = this.getAttribute('active-club-member') === 'true';
    this.clubDiscountEligible = this.getAttribute('club-discount-eligible') === 'true';
    this.athleticClubMemberProduct = this.getAttribute('athletic-club-member-product') === 'true';
    this.isAvailable = this.getAttribute('is-available') === 'true';
    this.productId = this.getAttribute('product-id');
    this.preMembershipSubscriber = this.getAttribute('pre-membership-subscriber') === 'true';
    // Get initial toggle state from attribute
    const toggleOnData = this.getAttribute('club-toggle');
    this.toggleOn = toggleOnData === 'true';
    this.handleClubPriceProgressBar({ data: window.__abc?.ShopifyCartData });
    // Get references to DOM elements
    this.oneTimeDetailsEl = this.querySelector('.onetime_pricing_details');
    this.oneTimeDetailsClubSuccessEl = this.querySelector('.onetime_pricing_details_club_success');
    this.pdpClubProgressBarWrapperEl = this.querySelector('.pdp_club_progress_bar_wrapper');
    this.subscribeAndSaveDetailsEl = this.querySelector('.subscribe_and_save_details');
    this.clubDetailsEl = this.querySelector('.club_membership_extra_details');
    this.pricingOptions = this.querySelectorAll('.pricing_option_type');

    this.employee = this.getAttribute('employee') === 'true';

    const bundleId = this.getAttribute('bundle-lines-id');
    if (bundleId) {
      const el = document.getElementById(bundleId);
      if (el) {
        try {
          // textContent is raw JSON → single parse
          this.bundleLines = JSON.parse(el.textContent.trim() || '[]');
        } catch (e) {
          console.error('Invalid bundle JSON in script tag:', e, el.textContent);
          this.bundleLines = [];
        }
      } else {
        console.warn('Bundle script element not found:', bundleId);
        this.bundleLines = [];
      }
    } else {
      this.bundleLines = [];
    }
    //console.log('bundleLines (parsed):', this.bundleLines);

    // Attach event listeners to pricing options
    this.pricingOptions.forEach((option) => {
      option.addEventListener('click', this.handleOptionClick);
      option.addEventListener('keypress', this.handleKeyPress); // For accessibility
    });

    const selectedOption = Array.from(this.pricingOptions).find((option) =>
      option.classList.contains('selected_pricing_option')
    );
    if (selectedOption) {
      //this.purchaseType = selectedOption.getAttribute('data-purchase-type');
      this.updatePurchaseType(selectedOption.getAttribute('data-purchase-type'));
    } else {
      // Fallback to default if no option is selected
      // this.purchaseType = 'oneTime';
    }
    //this.updatePurchaseType(this.purchaseType);

    // Subscribe to cart updates
    /*
    this.cartUpdateEnrichedUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdateEnriched, (event) => {
      this.cart = event.data.cart;
      this.cartMetaData = event.data.metafields;
      this.handleClubPriceProgressBar(event);
    });
    */
    window.addEventListener('cartUpdateEnriched', this.handleCartUpdateEnriched);

    // Listen for membership toggle events
    document.addEventListener('pdp-toggle-club-membership', this.handleMembershipToggle);

    const buildMySubscriptionBtn = document.querySelector('.build_my_subscription_btn');
    // console.log('buildMySubscriptionBtn', buildMySubscriptionBtn);
    if (buildMySubscriptionBtn) {
      buildMySubscriptionBtn.addEventListener('click', this.launchSubBuilder);
    }

    // Initialize UI based on current state
    this.updateUI();
    this.removeAttribute('hidden');
  }

  disconnectedCallback() {
    // Remove event listeners to prevent memory leaks
    this.pricingOptions.forEach((option) => {
      option.removeEventListener('click', this.handleOptionClick);
      option.removeEventListener('keypress', this.handleKeyPress);
    });

    if (this.cartUpdateEnrichedUnsubscriber) {
      this.cartUpdateEnrichedUnsubscriber();
    }

    const buildMySubscriptionBtn = this.querySelector('.build_my_subscription_btn');
    if (buildMySubscriptionBtn) {
      buildMySubscriptionBtn.removeEventListener('click', this.launchSubBuilder);
    }

    window.removeEventListener('cartUpdateEnriched', this.handleCartUpdateEnriched);
    document.removeEventListener('pdp-toggle-club-membership', this.handleMembershipToggle);
  }

  launchSubBuilder(event) {
    event.preventDefault();
    const subscriptionBuilder = document.querySelector('subscription-builder');
    if (!subscriptionBuilder) return;
    //subscriptionBuilder.open(event.target, null, null, this.productId, this.toggleOn);

    let startingBundle = null;
    if (Array.isArray(this.bundleLines) && this.bundleLines.length > 0) {
      startingBundle = this.bundleLines.map((line) => ({
        product_id: String(line.productId),
        quantity: Number(line.quantity || 1),
      }));
    }

    const startingProduct = startingBundle ? null : this.productId;
    subscriptionBuilder.open(
      event.target, // triggeredBy
      null, // subscriptionKey
      null, // builderType
      startingProduct, // startingProduct (null if bundle prefill)
      this.toggleOn, // clubMembershipToggleOn
      null,
      startingBundle,
      false // frequencyPanel
    );
  }

  handleCartUpdateEnriched(event) {
    //console.log('handleCartUpdateEnriched', event);
    const {
      cart,
      cartMetaFields,
      clubProductsInCart,
      clubProductsInCartCount,
      isClubProductInCart,
    } = event.detail;
    const progressBarEl = this.querySelector('.pdp_club_progress_bar');
    const neededForClubDiscountEl = this.querySelector('.needed_for_club_discount');

    this.cart = cart;
    this.cartMetaData = cartMetaFields;
    if (!progressBarEl) {
      console.warn('Progress bar element not found');
      return;
    }

    if (!neededForClubDiscountEl) {
      // console.error('needed_for_club_discount element not found');
      return;
    }

    const totalClubProductsInCart = clubProductsInCartCount;
    const targetProductsForDiscount = 4;
    const progressValue = Math.min(100, (totalClubProductsInCart / 4) * 100);

    //console.log('totalClubProductsInCart', totalClubProductsInCart);
    //console.log('progressValue', progressValue);

    progressBarEl.style.width = `${progressValue}%`;
    progressBarEl.setAttribute('aria-valuenow', Math.round(progressValue));

    this.neededForClubDiscount = Math.max(0, targetProductsForDiscount - totalClubProductsInCart);
    neededForClubDiscountEl.textContent = this.neededForClubDiscount;

    if (progressValue === 0) {
      progressBarEl.style.width = '10%'; // Base width when no progress
      progressBarEl.style.borderTopRightRadius = '9999px';
      progressBarEl.style.borderBottomRightRadius = '9999px';
    } else if (progressValue >= 100) {
      progressBarEl.style.width = '100%';
      progressBarEl.style.borderTopRightRadius = '0';
      progressBarEl.style.borderBottomRightRadius = '0';
    } else {
      progressBarEl.style.borderTopRightRadius = '9999px';
      progressBarEl.style.borderBottomRightRadius = '9999px';
    }

    this.updateUI();
  }
  handleClubPriceProgressBar(event) {
    // console.log('handleClubPriceProgressBar', event);
    const progressBarEl = this.querySelector('.pdp_club_progress_bar');
    const neededForClubDiscountEl = this.querySelector('.needed_for_club_discount');

    if (!progressBarEl) {
      console.warn('Progress bar element not found');
      return;
    }

    if (!neededForClubDiscountEl) {
      // console.error('needed_for_club_discount element not found');
      return;
    }

    const totalClubProductsInCart = event.data.clubProductsInCartCount;
    const targetProductsForDiscount = 4;

    const progressValue = Math.min(100, (totalClubProductsInCart / 4) * 100);
    //console.log('totalClubProductsInCart', totalClubProductsInCart);
    //console.log('progressValue', progressValue);
    // Update progress bar
    progressBarEl.style.width = `${progressValue}%`;
    progressBarEl.setAttribute('aria-valuenow', Math.round(progressValue));

    // Update needed_for_club_discount element
    this.neededForClubDiscount = Math.max(0, targetProductsForDiscount - totalClubProductsInCart);
    neededForClubDiscountEl.textContent = this.neededForClubDiscount;

    if (progressValue === 0) {
      // Adjust border radii based on progress value
      progressBarEl.style.width = '10%'; // Base width when no progress
      progressBarEl.style.borderTopRightRadius = '9999px';
      progressBarEl.style.borderBottomRightRadius = '9999px';
    } else if (progressValue >= 100) {
      progressBarEl.style.width = '100%';
      progressBarEl.style.borderTopRightRadius = '0';
      progressBarEl.style.borderBottomRightRadius = '0';
    } else {
      progressBarEl.style.borderTopRightRadius = '9999px';
      progressBarEl.style.borderBottomRightRadius = '9999px';
    }

    this.updateUI();
  }

  handleMembershipToggle(event) {
    const { active } = event.detail;
    this.toggleOn = active;
    this.updateUI();
    const clubItem = this.cart.items?.find((item) => item.id == 40807499726929);
    //if (clubItem) productsToRemove.push(clubItem);

    if (!active) {
      this.dispatchEvent(
        new CustomEvent('club-membership-toggle-off', {
          bubbles: true,
          composed: true,
        })
      );

      if (clubItem) {
        const productsToRemove = [];
        productsToRemove.push(clubItem);
        const acMembersOnlyProducts = this.cartMetaData.filter((cartItem) => {
          if (cartItem.tags.includes('ACMemberOnly')) {
            return cartItem;
          }
        });
        if (acMembersOnlyProducts) {
          acMembersOnlyProducts.forEach((item) => {
            productsToRemove.push(item);
          });
        }
        const cartItems =
          document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

        //console.log('productsToRemove', productsToRemove);
        cartItems.removeBulk(productsToRemove);
        /*
      const cartItems =
        document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

      const clubProductIndex = this.cart.items.findIndex(
        (item) => item.product_id === 7232894435409
      );
      console.log('clubProductIndex', clubProductIndex);
      console.log('cartItems', cartItems);
      if (clubProductIndex > -1) {
        cartItems.updateQuantity(clubProductIndex + 1, 0);
      }
        */
      }
    }
  }

  handleOptionClick(event) {
    const selectedOption = event.currentTarget;
    const selectedPurchaseType = selectedOption.getAttribute('data-purchase-type');

    if (selectedPurchaseType !== this.purchaseType) {
      this.updatePurchaseType(selectedPurchaseType);
    }
  }

  handleKeyPress(event) {
    // Allow toggling via keyboard (Enter or Space keys)
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      const selectedOption = event.currentTarget;
      const selectedPurchaseType = selectedOption.getAttribute('data-purchase-type');

      if (selectedPurchaseType !== this.purchaseType) {
        this.updatePurchaseType(selectedPurchaseType);
      }
    }
  }

  updatePurchaseType(newType) {
    // Update the purchaseType variable
    this.purchaseType = newType;
    //console.log('newType', newType);
    // Update the selected_pricing_option class
    this.pricingOptions.forEach((option) => {
      const optionType = option.getAttribute('data-purchase-type');
      if (optionType === newType) {
        option.classList.add('selected_pricing_option');
        option.setAttribute('aria-pressed', 'true');
      } else {
        option.classList.remove('selected_pricing_option');
        option.setAttribute('aria-pressed', 'false');
      }
    });

    this.updateUI();

    // Dispatch a custom event to notify other parts of the application
    this.dispatchEvent(
      new CustomEvent('purchase-type-changed', {
        detail: { purchaseType: this.purchaseType },
        bubbles: true,
        composed: true,
      })
    );
  }

  updateUI() {
    const productForms = document.querySelectorAll('product-form');
    productForms.forEach((productForm) => {
      productForm.clubToggleOn = this.toggleOn;
    });

    const sasValuePropGridNoClubEl = this.querySelector('.sas_value_prop_grid_no_club');
    const sasValuePropGridClubEl = this.querySelector('.sas_value_prop_grid_w_club');

    const priceContainerToggleOffEls = this.querySelectorAll('.price-container_toggle_off');
    const priceContainerToggleOnEls = this.querySelectorAll('.price-container_toggle_on');
    const sasCtaWrapperEl = document.querySelector('.sas_cta_wrapper');
    const qtyCtaGroupingEl = document.querySelector('.qty_cta_grouping');
    const subscribeAndSavePricingOptionEl = document.querySelector(
      '.subscribe_and_save_pricing_option'
    );
    if (this.isAvailable) {
      //show/hide subscription call out if members only
      if (subscribeAndSavePricingOptionEl) {
        if (this.athleticClubMemberProduct) {
          subscribeAndSavePricingOptionEl.style.display = 'none';
        } else {
          subscribeAndSavePricingOptionEl.style.display = 'block';
        }
      }

      if (this.purchaseType == 'subscribeAndSave') {
        if (this.athleticClubMemberProduct) {
          qtyCtaGroupingEl.classList.remove('active');
          sasCtaWrapperEl.classList.remove('active');
        }
        sasCtaWrapperEl.classList.add('active');

        qtyCtaGroupingEl.classList.remove('active');
      } else {
        if (this.athleticClubMemberProduct && !this.toggleOn) {
          if (!this.activeClubMember && !this.preMembershipSubscriber && !this.employee) {
            qtyCtaGroupingEl.classList.remove('active');
          } else {
            qtyCtaGroupingEl.classList.add('active');
          }
          sasCtaWrapperEl.classList.remove('active');
        } else {
          sasCtaWrapperEl.classList.remove('active');
          qtyCtaGroupingEl.classList.add('active');
        }
      }

      // Only show club price (toggle_on) when user has club AND product is club discount eligible
      const showClubPrice = (this.toggleOn || this.activeClubMember) && this.clubDiscountEligible;
      const showClubSuccessMessage =
        showClubPrice && this.neededForClubDiscount <= 0 && this.purchaseType === 'oneTime';

      if (showClubPrice) {
        if (this.neededForClubDiscount <= 0) {
          if (priceContainerToggleOffEls) {
            priceContainerToggleOffEls.forEach((el) => el.classList.remove('active'));
          }
          if (priceContainerToggleOnEls) {
            priceContainerToggleOnEls.forEach((el) => el.classList.add('active'));
          }
        }

        if (this.clubDetailsEl) {
          this.clubDetailsEl.style.display = 'block';
        }
        if (this.purchaseType === 'oneTime') {
          if (this.neededForClubDiscount > 0) {
            if (this.oneTimeDetailsEl) this.oneTimeDetailsEl.style.display = 'flex';
            if (this.oneTimeDetailsClubSuccessEl) this.oneTimeDetailsClubSuccessEl.style.display = 'none';
          } else {
            if (this.oneTimeDetailsEl) this.oneTimeDetailsEl.style.display = 'none';
            if (this.oneTimeDetailsClubSuccessEl) this.oneTimeDetailsClubSuccessEl.style.display = 'none';
          }

          if (this.pdpClubProgressBarWrapperEl) {
            this.pdpClubProgressBarWrapperEl.style.display = 'block';
          }
          if (this.subscribeAndSaveDetailsEl) {
            this.subscribeAndSaveDetailsEl.style.display = 'none';
          }
        } else if (this.purchaseType === 'subscribeAndSave') {
          if (this.oneTimeDetailsEl) {
            this.oneTimeDetailsEl.style.display = 'none';
          }
          if (this.pdpClubProgressBarWrapperEl) {
            this.pdpClubProgressBarWrapperEl.style.display = 'none';
          }
          if (this.oneTimeDetailsClubSuccessEl) {
            this.oneTimeDetailsClubSuccessEl.style.display = 'none';
          }
          if (this.subscribeAndSaveDetailsEl) {
            this.subscribeAndSaveDetailsEl.style.display = 'block';
          }

          sasValuePropGridNoClubEl.style.display = 'none';
          sasValuePropGridClubEl.style.display = 'grid';
        }
      } else {
        // Show regular/sale price (e.g. product not club discount eligible)
        if (priceContainerToggleOffEls) {
          priceContainerToggleOffEls.forEach((el) => el.classList.add('active'));
        }
        if (priceContainerToggleOnEls) {
          priceContainerToggleOnEls.forEach((el) => el.classList.remove('active'));
        }

        if (this.oneTimeDetailsEl) {
          this.oneTimeDetailsEl.style.display = 'none';
        }
        if (this.pdpClubProgressBarWrapperEl) {
          this.pdpClubProgressBarWrapperEl.style.display = 'none';
        }
        if (this.oneTimeDetailsClubSuccessEl) {
          this.oneTimeDetailsClubSuccessEl.style.display = 'none';
        }

        if (this.clubDetailsEl) {
          this.clubDetailsEl.style.display = 'none';
        }

        if (this.purchaseType === 'subscribeAndSave') {
          this.subscribeAndSaveDetailsEl.style.display = 'block';
          sasValuePropGridNoClubEl.style.display = 'grid';
          sasValuePropGridClubEl.style.display = 'none';
        } else {
          if (this.subscribeAndSaveDetailsEl) {
            this.subscribeAndSaveDetailsEl.style.display = 'none';
          }
        }
      }

      if (showClubSuccessMessage && this.oneTimeDetailsClubSuccessEl) {
        this.oneTimeDetailsClubSuccessEl.style.display = 'flex';
      }
    }
  }
}

customElements.define('pdp-purchase-options', PdpPurchaseOptions);
